<template>
  <div>
    <common-form></common-form>
  </div>  
</template>
<script>
import commonForm from './paramForm.vue'
export default {
  data () {
    return {}
  },
  components: {
    commonForm
  }
}
</script>




// WEBPACK FOOTER //
// add.vue?d02fa720